import axios from "axios";
import { apiRest } from "./constants";
import { encodeToken } from "./utils";
import { apiToken, apiTokenNotDecode } from "./requests";

export const logIn = (data = null) => {
  let path = "customer-login";
  return apiTokenNotDecode(data, path);
};

export const register = (data) => {
  let path = "customer-register";
  return axios.post(apiRest + path, { token: encodeToken(data) }, { withCredentials: true }).then(response => response.data).catch(() => ({ error: true }));
};

export const validateLogIn = (data) => {
  let path = "verify-customer";
  return apiToken(data, path);
};

export const recoverPassword = (data = null) => {
  let path = "forgot-password";
  return axios.post(apiRest + path, data, { withCredentials: true }).then(response => response.data).catch(() => ({ error: true }));
};

export const resetPassword = (data) => {
  let path = "reset-password";
  return apiToken(data, path);
};

export const sendCustomerVerificationCode = (data) => {
  let path = "send-customer-verification-code";
  return apiToken(data, path);
};

export const verifyCode = (data) => {
  let path = "verify-customer";
  return apiToken(data, path);
};

//********** TESTEADAS ARRIBA **************//
/*
export const logOut = (data = null) => {
  let path = "logout";
  return apiGet(path);
};

export const register = (data = null) => {
  let path = "login/register";
  return api(data, path);
};



export const changePasswordByEmail = (data = null) => {
  let path = "login/change-password";
  return api(data, path);
};

export const googleLogIn = (data = null) => {
  let path = "login/google";
  return api(data, path);
};

export const analytics = (data = null) => {
  let path = "analytics";
  return apiGet(path);
};

/*export const saveAnalytics = (data = null) => {
  let path = "saveAnalytics";
  api(data, path);
};

export const login = (data = null) => {
  let path = "login";
  let headers = {
    method: "POST",
    body: JSON.stringify({ token: token, data: data }),
  };

  return fetch(url + path, headers)
    .then((response) => response.json())
    .then((json) => {
      return json;
    })
    .catch((error) => {
      console.error(error);
    });
};

export const newAccount = (data = null) => {
  let path = "newUser";
  let headers = {
    method: "POST",
    body: JSON.stringify({ token: token, data: data }),
  };

  return fetch(url + path, headers)
    .then((response) => response.json())
    .then((json) => {
      return json;
    })
    .catch((error) => {
      console.error(error);
    });
};

export const googleLogin = (data = null) => {
  let path = "googleLogin";
  let headers = {
    method: "POST",
    body: JSON.stringify({ token: token, data: data }),
  };

  return fetch(url + path, headers)
    .then((response) => response.json())
    .then((json) => {
      return json;
    })
    .catch((error) => {
      console.error(error);
    });
};*/

// OAuth credentials never pass through the legacy request logger.
export const getGoogleLoginConfiguration = async () => {
  try { return (await axios.get(apiRest + "google-login-config", { withCredentials: true })).data; }
  catch { return { error: true }; }
};
export const googleCustomerLogin = async credential => {
  try { return (await axios.post(apiRest + "customer-google-login", { credential }, { withCredentials: true })).data; }
  catch (error) { return { error: true, message: error.response?.data?.message || "No se pudo conectar con Google. Inténtalo de nuevo." }; }
};
